enum ControlKind {
  PAGE = 'page',
  TEXT = 'text',
  READONLY_TEXT = 'readonly_text',
  SIGNATURE = 'signature',
  NUMERIC = 'numeric',
  DATE = 'date',
  SELECT = 'select',
  IMAGE = 'image',
  CALCULATED_VALUE = 'calculated_value',
  ATTACHMENT = 'attachment',
  TIME = 'time',
  NOT_DEFINED = 'not_defined'
}

export default ControlKind;
